import { render, staticRenderFns } from "./Prices.vue?vue&type=template&id=012b6a7f&"
import script from "./Prices.vue?vue&type=script&lang=js&"
export * from "./Prices.vue?vue&type=script&lang=js&"
import style0 from "./Prices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports